import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import type { StoryImportNotice as StoryImportNoticeState } from "@/features/story-import/story-import.types";

interface StoryImportNoticeProps {
  notice: StoryImportNoticeState;
  actionLabel?: string | null;
  onAction?: (() => void) | null;
  onDismiss?: () => void;
}

export function StoryImportNotice({
  notice,
  actionLabel = null,
  onAction = null,
  onDismiss,
}: StoryImportNoticeProps) {
  const { t } = useTranslation();
  const toneClasses =
    notice.kind === "error"
      ? "border-rose-200/70 bg-rose-50/90 text-rose-950"
      : "border-emerald-200/70 bg-emerald-50/90 text-emerald-950";

  return (
    <div className={`rounded-[1.75rem] border px-5 py-4 text-sm shadow-vellum ${toneClasses}`}>
      <div className="flex flex-col gap-3 lg:flex-row lg:items-start lg:justify-between">
        <p>{t(notice.message)}</p>
        <div className="flex flex-wrap justify-end gap-2">
          {actionLabel && onAction ? (
            <Button onClick={onAction} size="sm" type="button" variant="outline">
              {t(actionLabel)}
            </Button>
          ) : null}
          {onDismiss ? (
            <Button onClick={onDismiss} size="sm" type="button" variant="ghost">
              {t("projects.actions.dismiss")}
            </Button>
          ) : null}
        </div>
      </div>
    </div>
  );
}
